import { render, staticRenderFns } from "./ReportePendientePieChart.vue?vue&type=template&id=4e1308a6"
import script from "./ReportePendientePieChart.vue?vue&type=script&lang=js"
export * from "./ReportePendientePieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports